
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notes/[id]",
      function () {
        return require("private-next-pages/notes/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notes/[id]"])
      });
    }
  